import { memo } from 'react';
import { Link } from 'react-router-dom';
import { List, ListItemButton, ListItemIcon, Typography } from '@mui/material';

import { adminDrawerItemList, driverDrawerItemList, permission } from '../../const/commonConst';
import theme from '../../../theme';

type SideBarItemPropsType = {
	permissionNum: number;
	handleDrawerClose: () => void;
};

// 権限によりドロワーのリストを選択する関数
const getDrawerItemList = (permissionNum: number) => {
	switch (permissionNum) {
		case permission.id.driver:
			return driverDrawerItemList;
		case permission.id.admin:
			return adminDrawerItemList;
		case permission.id.sales:
			return adminDrawerItemList;
		case permission.id.super:
			return adminDrawerItemList;
		default:
			return driverDrawerItemList;
	}
};

/**
 * サイドバーのアイテム
 */
const SideBarItem = (props: SideBarItemPropsType) => {
	const { permissionNum, handleDrawerClose } = props;
	const drawerItemList = getDrawerItemList(permissionNum);

	return (
		<List>
			{drawerItemList.map((drawerItem, index) => (
				<Link to={drawerItem.path} key={drawerItem.path}>
					<ListItemButton id={`drawerItem${index}`} onClick={handleDrawerClose}>
						<ListItemIcon sx={{ color: theme.palette.common.black }}>
							<drawerItem.icon />
						</ListItemIcon>
						<Typography
							sx={{
								fontSize: 14,
								color: theme.palette.common.black,
							}}
						>
							{drawerItem.name}
						</Typography>
					</ListItemButton>
				</Link>
			))}
		</List>
	);
};

export default memo(SideBarItem);
